import create from "zustand";

interface StoreState {
  isMatrizSubmitAllowed: boolean;
  isMatrizSubmitted: boolean;
  classesOperacoes: string[];
  planoOperacionalOperacaoTalhaoIds: string[];
  centroCusto: string | undefined;
  equipe: string | undefined;
  equipeNome: string | undefined;
  operacao: string | undefined;
  operacaoNome: string | undefined;
  previsaoInicio: any;
  previsaoEncerramento: any;
  sistemaAplicacao: string | undefined;
  tipoBico: string | undefined;
  vazaoProgramada: string | undefined;
  quantidadeTanques: string | undefined;
  capacidadeTanque: string | undefined;
  volumeTanqueExtra: string | undefined;
  larguraFaixa: string | undefined;
  observacoes: string | undefined;

  setIsMatrizSubmitted: (isMatrizSubmitted: boolean) => void;
  setIsMatrizSubmitAllowed: (isMatrizSubmitAllowed: boolean) => void;
  setCentroCusto: (centroCusto: string | undefined) => void;
  setEquipe: (equipe: string | undefined) => void;
  setEquipeNome: (equipeNome: string | undefined) => void;
  setOperacao: (operacao: string | undefined) => void;
  setOperacaoNome: (operacaoNome: string | undefined) => void;
  setPrevisaoInicio: (previsaoInicio: any) => void;
  setPrevisaoEncerramento: (previsaoEncerramento: any) => void;
  setSistemaAplicacao: (sistemaAplicacao: string | undefined) => void;
  setTipoBico: (tipoBico: string | undefined) => void;
  setVazaoProgramada: (vazaoProgramada: string | undefined) => void;
  setQuantidadeTanques: (quantidadeTanques: string | undefined) => void;
  setCapacidadeTanque: (capacidadeTanque: string | undefined) => void;
  setVolumeTanqueExtra: (volumeTanqueExtra: string | undefined) => void;
  setLarguraFaixa: (larguraFaixa: string | undefined) => void;
  setObservacoes: (observacoes: string | undefined) => void;
  setClassesOperacoes: (classesOperacoes: string | string[]) => void;
  setPlanoOperacionalOperacaoTalhaoIds: (planoOperacionalOperacaoTalhaoIds: string | string[]) => void;
  reset: () => void;
}

const useStore = create<StoreState>((set) => ({
  isMatrizSubmitted: false,
  isMatrizSubmitAllowed: false,
  classesOperacoes: [],
  planoOperacionalOperacaoTalhaoIds: [],
  centroCusto: undefined,
  equipe: undefined,
  equipeNome: undefined,
  operacao: undefined,
  operacaoNome: undefined,
  previsaoInicio: undefined,
  previsaoEncerramento: undefined,
  sistemaAplicacao: undefined,
  tipoBico: undefined,
  vazaoProgramada: undefined,
  quantidadeTanques: undefined,
  capacidadeTanque: undefined,
  volumeTanqueExtra: undefined,
  larguraFaixa: undefined,
  observacoes: undefined,

  setIsMatrizSubmitted: (isMatrizSubmitted) => {
    set(state => ({ isMatrizSubmitted }));
  },
  setIsMatrizSubmitAllowed: (isMatrizSubmitAllowed) => {
    set(state => ({ isMatrizSubmitAllowed }));
  },
  setCentroCusto: (centroCusto) => {
    set(state => ({ centroCusto }));
  },
  setEquipe: (equipe) => {
    set(state => ({ equipe }));
  },
  setEquipeNome: (equipeNome) => {
    set(state => ({ equipeNome }));
  },
  setOperacao: (operacao) => {
    set(state => ({ operacao }));
  },
  setOperacaoNome: (operacaoNome) => {
    set(state => ({ operacaoNome }));
  },
  setPrevisaoInicio: (previsaoInicio) => {
    set(state => ({ previsaoInicio }));
  },
  setPrevisaoEncerramento: (previsaoEncerramento) => {
    set(state => ({ previsaoEncerramento }));
  },
  setSistemaAplicacao: (sistemaAplicacao) => {
    set(state => ({ sistemaAplicacao }));
  },
  setTipoBico: (tipoBico) => {
    set(state => ({ tipoBico }));
  },
  setVazaoProgramada: (vazaoProgramada) => {
    set(state => ({ vazaoProgramada }));
  },
  setQuantidadeTanques: (quantidadeTanques) => {
    set(state => ({ quantidadeTanques }));
  },
  setCapacidadeTanque: (capacidadeTanque) => {
    set(state => ({ capacidadeTanque }));
  },
  setVolumeTanqueExtra: (volumeTanqueExtra) => {
    set(state => ({ volumeTanqueExtra }));
  },
  setLarguraFaixa: (larguraFaixa) => {
    set(state => ({ larguraFaixa }));
  },
  setObservacoes: (observacoes) => {
    set(state => ({ observacoes }));
  },
  setClassesOperacoes: (value) =>
    set((state) => ({
      classesOperacoes: Array.isArray(value)
        ? value
        : [...state.classesOperacoes, value],
    })),
  setPlanoOperacionalOperacaoTalhaoIds: (value) =>
    set((state) => ({
      planoOperacionalOperacaoTalhaoIds: Array.isArray(value)
        ? value
        : [...state.planoOperacionalOperacaoTalhaoIds, value],
    })),
  reset: () =>
    set((state) => ({
      classesOperacoes: state.classesOperacoes,
      planoOperacionalOperacaoTalhaoIds: state.planoOperacionalOperacaoTalhaoIds,
      centroCusto: undefined,
      equipe: undefined,
      equipeNome: undefined,
      operacao: undefined,
      operacaoNome: undefined,
      previsaoInicio: undefined,
      previsaoEncerramento: undefined,
      sistemaAplicacao: undefined,
      tipoBico: undefined,
      vazaoProgramada: undefined,
      quantidadeTanques: undefined,
      capacidadeTanque: undefined,
      volumeTanqueExtra: undefined,
      larguraFaixa: undefined,
      observacoes: undefined,
    })),
}));

export default useStore;
